import { Accordion } from '../../modules/accordion';
import { setUpAnchorLink } from '../../modules/anchorLink';
import { animateAll } from '../../modules/animation';
import { VisionToggle } from './VisionToggle';
import { ShowHeading } from './ShowHeading';
import { VideoBg } from './VideoBg';
import { selector as $$ } from '../../utils/selector';
import { store } from '../..';
import MicroModal from 'micromodal';

export class TopPage {
  constructor(ctx) {
    this.lang = ctx.lang;

    this.#init();
  }

  static exec(ctx = { lang: 'ja' }) {
    return new TopPage(ctx);
  }

  #init() {
    // 一旦アニメーション反映のためIEの場合一度だけリロードさせる
    // 一時的処置
    if (store.isIE && window.name !== 'ie') {
      window.location.reload();
      window.name = 'ie';
    } else {
      window.name = '';
    }

    // ブラウザバック時のリロード処理
    window.addEventListener('pageshow', () => {
      if (window.performance.navigation.type == 2) {
        location.reload();
      }
    });

    //アンカースクロール処理
    setUpAnchorLink();

    // アニメーション処理
    animateAll();

    // アコーディオン処理
    const accordion = new Accordion();
    accordion.setup();

    $$('.js-visionToggle').forEach((i) => new VisionToggle(i));

    $$('.js-title-text3').forEach((i) => new ShowHeading(i));

    const videoBg = new VideoBg($$('.js-movie')[0], this.lang);

    MicroModal.init({
      disableScroll: true,
      onShow: () => {
        videoBg.pause();
      },
      onClose: (modal) => {
        videoBg.play();

        // VideoBgでvideojsは読み込み済
        if (modal.id === 'modal-1') {
          videojs.getPlayer('modal-video-1').pause();
        } else {
          videojs.getPlayer('modal-video-2').pause();
        }
      }
    });
  }
}
